import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isWebSocketActive: true, 
};

const webSocketSlice = createSlice({
  name: "webSocket",
  initialState,
  reducers: {
    startWebSocket: (state) => {
      state.isWebSocketActive = true; 
    },
    terminateWebSocket: (state) => {
      state.isWebSocketActive = false; 
    },
    resetWebSocket: (state) => {
      state.isWebSocketActive = true; 
    },
  },
});

export const { terminateWebSocket, resetWebSocket, startWebSocket } = webSocketSlice.actions;
export default webSocketSlice.reducer;
